/* eslint-disable react/require-default-props */
import React from 'react';

interface ChevronProps {
  name: string;
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
}

const Chevron: React.FC<ChevronProps> = (props: ChevronProps) => {
  const { name = '', width, height, className, fill } = props;

  const isDownMob = name === 'down-mob';
  const isUpMob = name === 'up-mob';
  const isDown = name === 'down';
  const isRight = name === 'right';

  const valueWidth = () => {
    if (isDownMob || isUpMob) return width || 15;
    if (isDown || isRight) return width || 24;
    return 0;
  };

  const valueHeight = () => {
    if (isDownMob || isUpMob) return height || 9;
    if (isDown || isRight) return height || 24;
    return 0;
  };

  const valueViewBox = () => {
    if (isDownMob || isUpMob) return '0 0 15 9';
    if (isDown || isRight) return '0 0 24 24';
    return '';
  };

  const valueD = () => {
    if (isDownMob) return 'M1 1L7.54069 8L14 1.08001';
    if (isUpMob) return 'M14 8L7.45931 1L1 7.91999';
    if (isDown) return 'M4 9L12 17L20 9';
    if (isRight) return 'M8.5 19L15.5 12.4593L8.58001 6';
    return '';
  };

  const valueStroke = () => {
    if (isDownMob || isUpMob) return fill || '#0099CC';
    if (isDown) return fill || '#444';
    if (isRight) return fill || '#AFAFAF';
    return '';
  };

  return (
    <div data-testid="chevron">
      <svg
        width={valueWidth()}
        height={valueHeight()}
        viewBox={valueViewBox()}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d={valueD()}
          stroke={valueStroke()}
          strokeWidth={isDown || isRight ? 2 : ''}
          strokeLinecap={isRight ? 'inherit' : 'round'}
          strokeLinejoin={isRight ? 'inherit' : 'round'}
          fill={isDown || isRight ? 'white' : ''}
        />
      </svg>
    </div>
  );
};

export default Chevron;
